// extracted by mini-css-extract-plugin
export default {"navbarLogo":"styles_navbarLogo__v1dwp","formLogo":"styles_formLogo__q2-z0"};